import { useState } from 'react';

import { Icon } from '@atom/mui';
import { SearchIcon } from '@atom/mui/icons';
import { MapSearch } from '@atom/types/map';

import SearchAutocomplete from './SearchAutocomplete';
import useMapSearch from './useMapSearch';

import classes from './toolbar.module.css';

type SearchBoxProps = {
  initialSearchTerm?: string;
  onSearchChange?: (search: MapSearch) => void;
  compactToolbars?: boolean;
};

const SearchBox = ({
  initialSearchTerm,
  onSearchChange,
  compactToolbars = false,
}: SearchBoxProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const search = useMapSearch({ initialSearchTerm, onSearchChange });

  return (
    <div
      className={`${classes.searchBox}${
        compactToolbars ? ` ${classes.searchBoxCompact}` : ''
      }`}
      data-cy="atomMapSearch"
      ref={setAnchorEl}
    >
      <SearchAutocomplete
        search={search}
        anchorEl={anchorEl}
        startAdornment={<Icon icon={SearchIcon} />}
      />
    </div>
  );
};

export default SearchBox;
